<template>
  <h1 class="wobble-heart center-me ">
    <i
      class="fas fa-heart animate__animated animate__wobble animate__infinite"
    ></i>
  </h1>
</template>

<script>
export default {
  name: "WobbleHeart"
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";

.wobble-heart {
  color: $action-red;
  z-index: 1000000;
  height: 100vh;
  width: 100vw;
  position: fixed;
  background: rgba(255, 255, 255, 0.6);
  top: 0;
  margin-top: 0;
}
</style>
